module.exports = __webpack_public_path__ + "img/company49.1ded90eb.png";